import React, { useState, useEffect, useRef } from 'react'
import './nav.css'
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NavItemsMobile({ isAdmin, calendarUrl, showBookNow, showPrices, showBlogs }) {
    const { t } = useTranslation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const containerRef = useRef(null);

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    useEffect(() => {
        if (!isMenuOpen) return;

        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                closeMenu();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isMenuOpen]);

    const navLinks = isAdmin
        ? t("nav_links_admin", { returnObjects: true })
        : t("nav_links", { returnObjects: true });

    const filteredLinks = navLinks.filter((item) => {
        if (item === "prices" && !showPrices) return false;
        if (item === "blog" && !showBlogs) return false;
        return true;
    });

    return (
        <div className="mobile-nav-container" ref={containerRef}>
            <button
                className="mobile-nav-toggle"
                onClick={toggleMenu}
                aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
                aria-expanded={isMenuOpen}
                type="button"
            >
                <span className="hamburger-lines" aria-hidden="true">
                    <span />
                    <span />
                    <span />
                </span>
            </button>

            {isMenuOpen && (
                <>
                    <div className="mobile-menu-overlay" onClick={closeMenu} />
                    <div className="mobile-menu-dropdown">
                        {filteredLinks.map((item) => {
                            const urlPath = item.toLowerCase().replace(/\s+/g, "-");
                            const to = isAdmin ? `edit/${item}` : `/${urlPath}`;

                            return (
                                <NavLink
                                    key={item}
                                    className="mobile-menu-item"
                                    to={to}
                                    onClick={closeMenu}
                                >
                                    {t(item)}
                                </NavLink>
                            );
                        })}
                    </div>
                </>
            )}
        </div>
    );
}
